import React, { Component } from 'react';
import { Trans } from "react-i18next";

import { NavLink } from 'react-router-dom';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
//import Swiper from 'react-id-swiper';
import axios from 'axios';
//import Cookies from 'universal-cookie';
import SideBar from "./SideBar";
import SideNav from "react-simple-sidenav";
import "../../config/i18n";
import { withTranslation } from "react-i18next"; 
import Loader from 'react-loader-spinner';
// import Cookies from 'universal-cookie';

import ls from "local-storage"; 
import { options } from "../../config/options";

class PaymentSuccPage extends Component { 
    
    constructor(props) {
        super(props);
        this.loggedIn = sessionStorage.getItem('loggedin');
        this.homeLink = this.homeLink.bind(this);   
        this.state = {
            wallet_amount:"",
            api_url:localStorage.getItem('api_url'),
            showNav3: false,user_details:'',
            currency_code:"",
            customer_id:"",
            modal4: false,
            lang: ls.get('LangKeySet') || options[0],
            langKey: ls.get('LangValue'),
            take_from_wallet : false,
            payable_amount : 0,
            wallet_detect_amount : 0,
            minus_wallet_amount : 0,
            disabled : false,
            backdrop : true,
            modal6: false,
        }
       
        
    }
    homeLink() { 
        this.setState({
            modal4 : false,
        })
        this.props.history.push("/app");  
        window.location.reload();
    }
    addDefaultSrc(ev){
        ev.target.src =  require('../../assets/img/howzu-logo-default.png')
    }

    closeModal(tabId) {
        this.setState({
            [tabId]: false
        });
        if(tabId == 'modal6'){
            this.props.history.push("../../Banner"); 
        }else{

        this.props.history.push("/app"); 
        window.location.reload();
    }
    }
    componentDidMount(){
        let purchase_type = this.props.match && this.props.match.params && this.props.match.params.purchase_type;
        let payment_session_id = this.props.match && this.props.match.params && this.props.match.params.payment_session_id;

        var take_from_wallet = JSON.parse(localStorage.getItem('for_stripe_payment_take_from_wallet')); 
        var payable_amount = JSON.parse(localStorage.getItem('for_stripe_payment_payable_amount')); 
        var minus_wallet_amount = JSON.parse(localStorage.getItem('for_stripe_payment_minus_wallet_amount')); 

        var package_id;
        var price;
        var currency;
        var curr_price;
        var api_url;
        if(payment_session_id && purchase_type) {
            if(purchase_type === 'premium') {
                package_id = JSON.parse(localStorage.getItem('selected_premium')); 
                price = JSON.parse(localStorage.getItem('premium_price')); 
                curr_price = JSON.parse(localStorage.getItem('currency_premium_price')); 
                api_url = this.state.api_url+'stripepaypremium';
            }
            else if(purchase_type === 'boost') {
                package_id = JSON.parse(localStorage.getItem('selected_boostpremium'));
                price = JSON.parse(localStorage.getItem('boostpremium_price')); 
                curr_price = JSON.parse(localStorage.getItem('currency_boostpremium_price')); 
                api_url = this.state.api_url+'stripepayboostpremium';
            }
            else if(purchase_type === 'superlike') {
                package_id = JSON.parse(localStorage.getItem('selected_superlikepremium'));
                price = JSON.parse(localStorage.getItem('superlikepremium_price')); 
                curr_price = JSON.parse(localStorage.getItem('currency_superlikepremium_price')); 
                api_url = this.state.api_url+'stripepaysuperlikepremium';
            }
            else if(purchase_type === 'banner') {
                package_id = JSON.parse(localStorage.getItem('banner_id'));
                price = JSON.parse(localStorage.getItem('bannerprice')); 
                curr_price = JSON.parse(localStorage.getItem('bannerprice')); 
                api_url = this.state.api_url+'bannerpayment';
            }
            
            currency=JSON.parse(localStorage.getItem('currency')); 

        }
        
       
        let data = new FormData();
        data.append('user_id', JSON.parse(localStorage.getItem('session_userid')));  
        data.append('language', this.state.langKey); 
        data.append('package_id', package_id); 
        data.append('purchase_type', purchase_type); 
        data.append('payable_amount', payable_amount); 
        data.append('take_from_wallet', take_from_wallet); 
        data.append('minus_wallet_amount', minus_wallet_amount); 
        data.append('currency_code', currency); 
        data.append('pay_nonce', payment_session_id); 
        
        axios({
            method: 'post',
            url: api_url,
            data: data, 
            config: { headers: {'Content-Type': 'multipart/form-data' }}
        }).then(res => {
            console.log(res);
          if(res.data.status !== false) { 

          if (res.data.type == "premium") {
                   this.setState({
                        modal4 : true,
                        backdrop : false,
                        message : res.data.message
                    })

                    localStorage.setItem('premium_popup', '1');
                    //localStorage.setItem('isrevealed', res.data.revealed_matches);
                }
          else if (res.data.message == "Amount successfully paid, now your banner is ready to display") {
                    this.setState({
                        message: res.data.message
                    });
                    this.setState({
                        modal6: true,
                        backdrop : false,
                    });
                   
                }else{    
                    this.setState({
                        modal4 : true,
                        backdrop : false,
                        message : res.data.message
                    })
                }
          } else {
            this.setState({
                modal4 : true,
                backdrop : false,
                message : res.data.message
            })
          }
        }); 
        
        
        
    }
   
    
    render() {
      
     


        return (
        <>
            {
                this.state.backdrop === true &&
                <div class="drop">
                    <div class="loaderrr">
                        <div className="loder-icon">
                                <Loader type="Bars" color="#ca2a1e" height={30} width={50} />   
                        </div>
                    </div>
                </div>
            }
            
            <div className="setting-page ">
                
                
                <Modal isOpen={this.state.modal4} toggle={this.homeLink} className="premiumPopup vertically-center apd5">
                    <ModalHeader toggle={this.homeLink}><h4 class="modal-title" style={{'marginTop':"10px"}}><Trans i18nKey={this.state.message}>{this.state.message}</Trans></h4></ModalHeader>
                    <ModalBody>
                        <div className="modal-body">
                            <div class="d-flex justify-content-end">
                                <div class="mr-3"><button class="border-0 bg-white pink-color" onClick={this.homeLink}><Trans i18nKey="Ok">Ok</Trans></button></div>
                            </div>
                        </div>
                    </ModalBody> 
                </Modal>

                <Modal isOpen={this.state.modal6} toggle={this.closeModal.bind(this, 'modal6')} className="premiumPopup vertically-center apd5">
                    <ModalHeader toggle={this.closeModal.bind(this, 'modal6')}><h4 class="modal-title" style={{'marginTop':"10px"}}><Trans i18nKey={this.state.message}>{this.state.message}</Trans></h4></ModalHeader>
                    <ModalBody>
                        <div className="modal-body">
                            <div class="d-flex justify-content-end">
                                <div class="mr-3"><button class="border-0 bg-white pink-color" onClick={this.closeModal.bind(this, 'modal6')}><Trans i18nKey="Ok">Ok</Trans></button></div>
                            </div>
                        </div>
                    </ModalBody> 
                </Modal>
                
                <div className="sidebarResp d-block d-lg-none">
                    <SideNav showNav={this.state.showNav3} onHideNav={() =>
                    this.setState({ showNav3: false })} title={
                    <div></div>
                    } items={[
                    <SideBar />
                    ]} />
                </div>
            </div>
        </>
        )
    }
}

export default withTranslation("translations")(PaymentSuccPage);